import { useState } from "react";
import { motion } from "framer-motion";
import { OBJECTS } from "../data/content";
import { SectionLabel, Reveal } from "./Reveal";

function ProductCard({ p, index }) {
  const [size, setSize] = useState(p.sizes[0]);
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.8, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="group"
      data-testid={`product-${p.id}`}
    >
      <div className="relative overflow-hidden rounded-sm bg-[color:var(--charcoal)] ring-1 ring-white/10 aspect-[4/5]">
        {/* spotlight */}
        <div className="absolute inset-0 opacity-70 group-hover:opacity-100 transition-opacity duration-700"
          style={{ background: "radial-gradient(120% 80% at 50% 0%, rgba(255,255,255,0.06), transparent 60%)" }} />
        <img
          src={p.image}
          alt={p.name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <span className="absolute top-4 right-4 track-label text-white/70">{p.price}</span>
      </div>

      <div className="mt-5">
        <h3 className="font-display steel-text text-xl md:text-2xl leading-none">{p.name}</h3>
        <p className="font-body text-white/45 text-sm mt-2 leading-relaxed">{p.desc}</p>

        <div className="flex items-center gap-2 mt-4">
          {p.sizes.map((s) => (
            <button
              key={s}
              onClick={() => setSize(s)}
              data-testid={`size-${p.id}-${s}`}
              className={`px-3 py-1.5 border text-[0.62rem] font-mono2 tracking-widest transition-all duration-300 ${
                size === s ? "border-white text-white bg-white/10" : "border-white/15 text-white/50 hover:border-white/40"
              }`}
            >
              {s}
            </button>
          ))}
        </div>

        <a
          href={p.buy}
          data-testid={`buy-${p.id}`}
          className="mt-5 flex items-center justify-between px-5 py-3.5 border border-white/15 hover:border-white hover:bg-white hover:text-black transition-all duration-400 group/btn"
        >
          <span className="track-label">ADD — {p.price}</span>
          <span className="track-label opacity-60 group-hover/btn:translate-x-1 transition-transform">→</span>
        </a>
      </div>
    </motion.div>
  );
}

export default function Objects() {
  return (
    <section id="objects" className="relative w-full py-24 md:py-36 px-5 md:px-10 bg-[color:var(--graphite)]" data-testid="section-objects">
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel index="04 / SHOP" id="objects-label">OBJECTS</SectionLabel>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <h2 className="font-display chrome-text text-5xl sm:text-6xl md:text-8xl leading-[0.9]">
            <Reveal text="OBJECTS" />
          </h2>
          <p className="font-body text-white/50 max-w-sm text-sm md:text-base">
            Limited physical artefacts. Storefront ready for Shopify integration.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {OBJECTS.map((p, i) => (
            <ProductCard key={p.id} p={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
